import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-communication-reply-icon',
  templateUrl: './communication-reply.component.html'
})
export class CommunicationReplyComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
